import * as React from "react";
import { ChevronDownIcon } from "lucide-react";

import { cn } from "./utils";

function NativeSelect({ className, ...props }: React.ComponentProps<"select">) {
    return (
        <div
            className="group/native-select relative has-[select:disabled]:opacity-50 w-full"
            data-slot="native-select-wrapper"
        >
            <select
                data-slot="native-select"
                className={cn(
                    "flex bg-white dark:bg-slate-900 disabled:opacity-50 px-3 py-2 pr-9 border border-slate-300 dark:border-slate-500 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-300 ring-offset-white focus-visible:ring-offset-2 dark:ring-offset-slate-900 w-full h-12 dark:text-slate-100 placeholder:text-slate-400 text-sm transition-[color,box-shadow] appearance-none disabled:cursor-not-allowed",
                    className
                )}
                {...props}
            />
            <ChevronDownIcon
                className="top-1/2 right-3.5 absolute opacity-50 size-4 text-muted-foreground -translate-y-1/2 pointer-events-none select-none"
                aria-hidden="true"
                data-slot="native-select-icon"
            />
        </div>
    );
}

function NativeSelectOption({ ...props }: React.ComponentProps<"option">) {
    return <option data-slot="native-select-option" {...props} />;
}

function NativeSelectOptGroup({ className, ...props }: React.ComponentProps<"optgroup">) {
    return <optgroup data-slot="native-select-optgroup" className={cn(className)} {...props} />;
}

export { NativeSelect, NativeSelectOptGroup, NativeSelectOption };
